/** Mirrors the backend guard: a persona name must slugify to something, so it needs a letter or digit. */
export const PERSONA_NAME_ERROR = "Name needs at least one letter or number";

const HAS_LETTER_OR_DIGIT = /[\p{L}\p{N}]/u;

export const isValidPersonaName = (name: string): boolean =>
  HAS_LETTER_OR_DIGIT.test(name);
